import $ from 'jquery';

const $nav = $('.page-header-nav');
const $allBtn = $nav.find('.page-header-nav__left .btn');
const $navCategories = $nav.find('.page-header-nav-categories');

$allBtn.on('click', () => $navCategories.toggleClass('d-block'));
